import type * as api from '@gitbook/api-client';
import { usePaletteTrigger } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { SidebarButton, SidebarItemIcon } from '@gitbook/spine-react';

import { OrganizationIcon } from '../../Components';
import { useGetSettingsPalette } from './SettingsPalette';

export function OrganizationButton(props: { organization: api.Organization }) {
    const { organization } = props;
    const palette = useGetSettingsPalette({ organization });
    const { triggerProps } = usePaletteTrigger({ palette });

    return (
        <SidebarButton
            size="large"
            icon={<OrganizationIcon organization={organization} />}
            label={organization.title}
            {...triggerProps}
        >
            <SidebarItemIcon icon={Icon.ChevronDown} size={14} />
        </SidebarButton>
    );
}
